module.exports = __webpack_public_path__ + "public/img/Komunikasi Efektif Dan Negosiasi Bagi Staf Penjualan.dfc5d058.png";